<template>
  <OverviewTab
    :market="market"
    :initial-fields="initialFields"
    :services="services"
    :title="titlePackage"
    :intro="intro"
  />
</template>

<script setup lang="ts">
import OverviewTab from '~/components/sustainability/OverviewTab.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

/*-------------------------------------
  Constants
-------------------------------------*/
const intro = {
  title:
    'Benchmark’s Rare Earths ESG Report is an annual subscription with quarterly updates.',
  body: [
    'Benchmark’s Rare Earths ESG Report is an annual subscription with quarterly updates.',
    'The report offers comprehensive coverage of the evolving ESG landscape in the upstream rare earths supply chain, forecasted trends and our Benchmark Global LCAs, which measure the environmental impact of producing both mined rare earths and refined rare earths.',
    'To keep subscribers up to date, the report contains individual assessments of all rare earths miners and refiners, with indicators measuring ESG performance alongside index ratings allocated based on our Benchmark’s Sustainability Index Methodology. Utilising data collected through Benchmark’s independent research and analysis, this report provides detailed and expert ESG assessment and monitoring of the rare earths industry.',
  ],
  images: {
    one: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,c_crop,h_1400,g_auto,w_400,dpr_auto/v1731423842/assets/esg/rare-earths/benchmarkminerals_Inside_the_rare_earth_separation_plant_a_work_56a2e7ce-051f-4576-ae83-acaabddaad31_tsf0ir.png',
      alt: 'Rare Earths Forecasts',
    },
    two: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,c_crop,h_800,g_auto,w_400,dpr_auto/v1731423841/assets/esg/rare-earths/benchmarkminerals_In_the_laboratory_an_engineer_in_a_blue_coat__7fa78d00-4f1d-4f2a-ac38-0850ff608c77_qejwnv.png',
      alt: 'Rare Earths Forecasts',
    },
    three: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,c_crop,h_800,g_auto,w_400,dpr_auto/v1731423842/assets/esg/rare-earths/benchmarkminerals_Inside_the_rare_earth_separation_plant_Focusi_09de9e0d-6d2a-47a4-a830-315299eaef16_sucuuv.png',
      alt: 'Rare Earths Forecasts',
    },
  },
}

const services = [
  {
    icon: 'services/icon-success-chart',
    description: 'Company-by-company ESG database',
  },
  {
    icon: 'services/icon-presentation',
    description: 'Materiality assessment and critical ESG analysis',
  },
  {
    icon: 'services/icon-idea',
    description: 'Access to Benchmark’s analysts',
  },
  {
    icon: 'services/icon-eco-earth',
    description: 'Benchmark Global Rare Earths LCA',
  },
  {
    icon: 'services/icon-consultancy',
    description: 'ESG news brief and global policy review',
  },
]

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  isTab: true,
  scrollToTop: false,
  middleware: 'redirect-tab',
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: string[]
}>()

const titlePackage = ref(`${props.market.name} ESG Report`)
</script>
